import Vue from "vue"
import VueRouter from "vue-router"
import store from "../store"
import Meta from "vue-meta"
import paths from "./paths"

const ifAuthenticated = (to, from, next) => {
  if (!store.getters["auth/isAuthenticated"]) {
    next("/login")
    return
  }
  const role = store.state.user.profile.role
  const forbidden = to.matched.some(
    (record) =>
      record.meta.restricted && role && !record.meta.restricted.includes(role)
  )
  if (forbidden) {
    next("/")
    return
  }
  next()
}

function route(path, view, name, props, children, redirect, meta) {
  return {
    name: name || view,
    path,
    meta: meta || {},
    props: props,
    redirect: redirect,
    children: children,
    beforeEnter: ifAuthenticated,
    component: (resovle) => import(`@/views/${view}.vue`).then(resovle),
  }
}

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters["auth/isAuthenticated"]) {
    next()
    return
  }
  next("/")
}

Vue.use(VueRouter)

// Create a new router
const router = new VueRouter({
  mode: "history",
  routes: paths
    .map((path) =>
      route(
        path.path,
        path.view,
        path.name,
        path.props,
        path.children,
        path.redirect,
        path.meta
      )
    )
    .concat([
      { path: "*", redirect: "/" },
      {
        name: "login",
        path: "/login",
        component: () => import("@/views/LoginPage"),
        beforeEnter: ifNotAuthenticated,
      },
      {
        name: "code",
        path: "/code",
        component: () => import("@/views/CodePage"),
        beforeEnter: ifNotAuthenticated,
      },
    ]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
})

Vue.use(Meta)

export default router
